import { makeStyles } from '@material-ui/core/styles';
import bgImg from "./images2/bgImage.jpg";
export default makeStyles(() => ({
    bg: {
        backgroundImage :`url(${bgImg})`,
        position: "fixed",
        minWidth: "100%",
        minHeight: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
    }
}))